export function PageMainBody(props) {
    const {children} = props

    return <div className={"mt-3"}>
        {children}
    </div>
}